import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../Context/LanguageContext';

function About() {
  const { language } = useContext(LanguageContext);
  const isArabic = language === 'ar';

  return (
    <div
      className={`position-relative container-fluid p-0 about ${isArabic ? 'text-end' : ''}`}
      dir={isArabic ? 'rtl' : 'ltr'}
      id="about"
      style={{ overflow: 'hidden', minHeight: '20vh', background: '#111' }}
    >
      {/* Background Video */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 0, overflow: 'hidden' }}>
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-100 h-100 about-bg-video"
          style={{ objectFit: 'cover', minHeight: '100%', minWidth: '100%', background: '#111' }}
          poster="/assets/images/logo1.png"
        >
          <source src="/assets/videos/about-bg.mp4" type="video/mp4" />
          <img src="/assets/images/logo1.png" alt="about background" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          Your browser does not support the video tag.
        </video>
        <div
          className="about-bg-overlay"
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
          }}
        />
      </div>

      {/* Content */}
      <div className="container p-5 position-relative" style={{ zIndex: 2 }}>
        <div className="row d-flex justify-content-center align-items-center h-100">
          {/* Text */}
          <div className="col-md-6 d-flex gap-3 flex-column text-white">
            <h2>{isArabic ? 'من نحن' : 'About Us'}</h2>
            <p
              style={{
                textAlign: isArabic ? 'right' : 'justify',
                display: 'block',
                lineHeight: '1.8',
              }}
            >
              {isArabic
                ? `في ديفورا، نُمكّن الأفراد والشركات من خلال حلول رقمية ذكية. نُبدع في تطوير البرمجيات، المنصات التعليمية، استراتيجيات التسويق، وأتمتة المبيعات، لنقدّم خدمات متكاملة تُحدث فرقاً حقيقياً. يجمع فريقنا بين الإبداع والخبرة والشغف بالتكنولوجيا، لنصنع تجارب تعليمية وتسويقية متطورة تساهم في النمو والنجاح.`
                : `At Devora, we empower individuals and businesses through smart digital solutions. We excel in software development, educational platforms, marketing strategies, and sales automation, offering integrated services that create real impact. Our team blends creativity, expertise, and passion to deliver innovative experiences that drive growth and success.`}
            </p>
            <div className="d-flex gap-2">
              <Link to="/about" className="btn btn-outline-light">
                {isArabic ? 'اعرف المزيد' : 'Learn More'}
              </Link>
            </div>
          </div>

          {/* Logo */}
          <div
            className="col-md-6 avatar-hero d-flex justify-content-center align-items-center"
            data-aos={isArabic ? 'fade-right' : 'fade-left'}
            data-aos-duration="1000"
          >
            <img
              src="/assets/images/logo1.png"
              alt="hero-img"
              className="img-fluid floating-logo"
              style={{ maxWidth: '300px', maxHeight: '300px' }}
            />
          </div>
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .about-bg-video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          object-fit: cover;
          z-index: 0;
        }
        .about-bg-overlay {
          pointer-events: none;
        }
        @media (max-width: 767.98px) {
          .about-bg-video {
            height: 60vh;
          }
        }
      `}</style>
    </div>
  );
}

export default About;
